/**
 *
 * @returns {import('../../types/store').InternalTokenStoreInterface}
 */
const build = (key) => {
    const cache = {
        get: () => localStorage.getItem(key),
        set: (tokens) => {
            localStorage.setItem(key, tokens);
        },
        remove: () => localStorage.removeItem(key),
    };

    return cache;
};

export default build;
